import { render, staticRenderFns } from "./EventsParallax.vue?vue&type=template&id=ec7be3d6&"
import script from "./EventsParallax.vue?vue&type=script&lang=js&"
export * from "./EventsParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports